import { useEffect, useState } from 'react';
import { tempoDecorrido } from '../utils/tempo';

const LIMITE_ALERTA = 20; // minutos — acima disso o pedido fica vermelho

/**
 * Mostra há quanto tempo o pedido espera, atualizando sozinho a cada 30s.
 * Passou de 20 minutos → texto vermelho (e o card ganha borda vermelha via
 * a classe `pedido-atrasado` fornecida pelo componente pai).
 */
export default function TempoDeEspera({ criadoEm }: { criadoEm: string }) {
  const [agora, setAgora] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setAgora(Date.now()), 30000);
    return () => clearInterval(timer);
  }, []);

  const minutos = Math.max(
    0,
    Math.floor((agora - new Date(criadoEm).getTime()) / 60000),
  );
  const atrasado = minutos >= LIMITE_ALERTA;

  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-medium ${
        atrasado ? 'text-red-400' : minutos >= 10 ? 'text-yellow-300' : 'text-gray-400'
      }`}
      title="Tempo desde que o pedido chegou"
    >
      ⏱️ {tempoDecorrido(criadoEm, agora)}
    </span>
  );
}